import { Cluster, ClusterStats, Marker, Renderer } from "@googlemaps/markerclusterer";

const MAX_Z_INDEX = 1000000;

const renderSingleCluster = (entryCount: number) => `<div class="google-map-cluster-wrapper">
  <svg fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    <circle cx="120" cy="120" opacity="1" r="70" />
    <circle cx="120" cy="120" opacity=".8" r="90" />
    <circle cx="120" cy="120" opacity=".5" r="110" />
    <circle cx="120" cy="120" opacity=".3" r="130" />
    <div class="google-map-cluster-count" style="z-index: ${MAX_Z_INDEX + entryCount + 1}">${entryCount}</div>
  </svg>
</div>`

export class ClusterRenderer implements Renderer {
  render(cluster: Cluster, _: ClusterStats, map: google.maps.Map): Marker {
    // @ts-expect-error - we need to store data on the marker
    const entryCount = cluster.markers.reduce((acc, marker) => acc + marker.data.entryCount, 0);

    const content = document.createElement("div");
    content.innerHTML = renderSingleCluster(entryCount);

    return new google.maps.marker.AdvancedMarkerElement({
      map,
      position: cluster.position,
      content,
      zIndex: MAX_Z_INDEX + entryCount,
    });
  }
}